// Route guard for the cash-only pages (the cashier, deposit limits, responsible
// gaming, the verify wizard): with CASH_ENABLED=0 there is nothing behind them
// — every /api/cash|rg|tax|kyc call answers 404 — so a bookmark, a stale native
// NAV_TO or a hand-typed URL lands on the book instead of a dead form. Runs
// AFTER `auth` in each page's middleware list, so anonymous users still get the
// sign-in bounce first and the redirect never leaks which pages exist.
export default defineNuxtRouteMiddleware(async () => {
  const { load } = useFeatures()
  const f = await load()
  if (!f.cash) return navigateTo('/', { replace: true })
})
